/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { FormControlLabel, Radio, Typography } from "@mui/material";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { useSelectFieldSchema } from "cms/fields/hooks/use-select-field-schema";
import { Avatar } from "cms/fields/layout/header/avatar";
import { useDispatch } from "react-redux";
import { setActiveFieldName, setFieldOpen } from "data/store/reducers/composer";
import { useFieldOpen } from "cms/fields/hooks/use-field-open";

const FieldEditorHeader = (props) => {

    const children = props?.children;
    const isActiveField = props?.isActiveField;
    const showActiveFieldSelector = props?.showActiveFieldSelector;
    const { field } = useCurrentDynamicField();
    const name = field?.name;
    const dispatch = useDispatch();
    const { getNamedField } = useFieldOpen(name);
    const schema = useSelectFieldSchema(name);
    const settings = schema?.settings;
    const label = settings?.label ?? "";
    const description = settings.description ?? "";
    
    const handleChangeActiveField = (event) => {
        event.stopPropagation();
        if (!isActiveField) {
            dispatch(setActiveFieldName(name));
        }
        const field = getNamedField(name);
        dispatch(setFieldOpen(field));
    };
    
    return (
        <div className='simplicity-composer-header-group-stack'>
            <div className='simplicity-composer-header-group fields'>
                <div className='simplicity-composer-header-container'>
                    <div className='simplicity-composer-header-subgroup'>
                        <Avatar />
                        <div className='simplicity-composer-header-wrapper'>
                            <Typography className='simplicity-composer-header-text fields'>
                                {label}
                            </Typography>
                            <Typography className='simplicity-composer-subHeader-text'>{description}</Typography>
                        </div>
                    </div>
                    {showActiveFieldSelector &&
                        <FormControlLabel
                            onClick={handleChangeActiveField}
                            className='active-field-radio'
                            control={
                                <Radio
                                    checked={isActiveField}
                                    // onClick used on form control to prevent multiple events firing
                                />
                            }
                            label='Active Field'
                        />
                    }
                </div>
            </div>
            {children}
        </div>
    );
};

export { FieldEditorHeader };
